<template>
    <div class="p-0">
        <b-navbar toggleable="xl" fixed="top" style="background-color: var(--white);">
            <b-container class="d-flex justify-content-bwtween align-items-center">
                
                <b-navbar-brand @click="handleNavClick('home')" style="cursor: pointer;">
                    <img class="imgMobile" src="../assets/page/header/logoHeader.png" alt="Logo da Frazzato Logistica"  style="width: 150px;">
                </b-navbar-brand>

                <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

                <b-collapse id="nav-text-collapse" is-nav >
                    <div class="w-100 d-flex justify-content-end">
                        <b-navbar-nav class="d-flex justify-content-center align-items-center w-100 flex-wrap">
                            <b-nav-item 
                                class="nav-link"
                                v-for="(nav, index) in navItems" :key="index"
                                :class="{ active: selectedNavItem === nav.id}"
                                @click="() => handleNavClick(nav.id)"
                            >
                                {{ nav.title }}
                            </b-nav-item>
                            <template v-if="isMobile === true">
                                <b-btn class="btn-standard" @click="() => handleNavClick('contacts')">
                                    Entre em Contato
                                </b-btn>
                            </template>
                        </b-navbar-nav>
                    </div>

                </b-collapse>
                <template v-if="isMobile === false">
                    <b-btn class="btn-standard" @click="() => handleNavClick('contacts')">
                        Entre em Contato
                    </b-btn>
                </template>
            </b-container>
            
        </b-navbar>

        <main class="main">
            <router-view></router-view>
        </main>

        <Footer />

    </div>
</template>

<script>
import Footer from '@/components/sections/Footer.vue';
import { scrollToSection } from '@/services/utils';

    export default {
        components: {Footer},

        data(){
            return {
                isMobile: true,
                selectedNavItem: '',
                navItems: [
                    { id: 'home', title: 'Início' },
                    { id: 'about', title: 'Quem Somos' },
                    { id: 'services', title: 'Serviços' },
                    { id: 'partners', title: 'Parceiros' },
                ]
            }
        },
        methods: {
            handleNavClick(id) {
                scrollToSection(id);
                this.selectedNavItem = id;
            },

            updateWidth(){
                this.isMobile = window.innerWidth  > 1200? false : true;
            }
        },

        mounted(){
            this.selectedNavItem = this.navItems[0].id;
            this.updateWidth();
            window.addEventListener("resize", this.updateWidth);
        },

        beforeDestroy() {
            window.removeEventListener("resize", this.updateWidth);
        }                                                                                                               
    }
</script>       

<style scoped lang="scss">
.nav-link {
    color: var(--black);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        font-weight: 600;
    }
}

::v-deep(.nav-link.active) {
    color: var(--primary);
    font-weight: bold;
}

@media screen and (max-width: 568px) {
    .imgMobile {
        width: 100px !important;
    }
}

</style>